import React from "react";

// BSU uses Zendesk so this is just a fallback
export default function HelpContent() {
    return (
        <div>
            For help, contact{" "}
            <a href="mailto:joypalmer@cwi.edu">joypalmer@cwi.edu</a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/cwi/siteComponents/helpContent.js